import { useEffect } from "react";
import React from "react";

import {
  Row,
  Col,
  Dropdown,
  Button,
  Avatar,
} from "antd";

import { useNavigate } from "react-router-dom";
import { UserOutlined, LogoutOutlined } from "@ant-design/icons";
import avtar from "../../assets/images/team-2.jpg";
import authService from "../../services/authService";
import { useUser } from "../../contexts/UserContext";

const toggler = [
  <svg
    width="20"
    height="20"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 448 512"
    key={0}
  >
    <path d="M16 132h416c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H16C7.163 60 0 67.163 0 76v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z"></path>
  </svg>,
];

interface HeaderProps {
  name: string;
  onPress: () => void;
}

const Header: React.FC<HeaderProps> = ({ name, onPress }) => {
  const navigate = useNavigate();
  const { user } = useUser();

  // Không được return kết quả của scrollTo: trình duyệt mới trả về Promise,
  // React sẽ coi đó là hàm cleanup và crash "n is not a function"
  useEffect(() => {
    window.scrollTo(0, 0);
  });

  const userMenuItems = [
    {
      key: "account",
      icon: <UserOutlined />,
      label: "Tài khoản",
      onClick: () => {
        navigate("/profile");
      },
    },
    {
      key: "logout",
      icon: <LogoutOutlined />,
      label: "Đăng xuất",
      onClick: () => {
        authService.logout();
      },
    },
  ];

  return (
    <Row>
      <Col xs={12} md={12} lg={0}>
        <h1 className="logo logo-md" style={{ paddingLeft: "20px" }}>
          Nebecom
        </h1>
      </Col>

      <Col xs={12} md={12} lg={24}>
        <div className="header-control">
          <Button
            type="link"
            className="sidebar-toggler"
            onClick={() => onPress()}
          >
            {toggler}
          </Button>
          <Dropdown
            menu={{
              items: userMenuItems,
            }}
            trigger={["click"]}
            placement="bottomRight"
          >
            <div
              className="user-dropdown-trigger"
              style={{
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                gap: "8px",
              }}
            >
              <Avatar icon={<UserOutlined />} size="small" style={{ backgroundColor: "#cecece" }} />
              <span style={{ color: "#111827", fontWeight: 500 }}>
                {user?.lastName} {user?.firstName}
              </span>
            </div>
          </Dropdown>
        </div>
      </Col>
    </Row>
  );
};

export default Header;
